import { VERIFY_ACCOUNT_REQUEST, VERIFY_ACCOUNT_SUCCESS, VERIFY_ACCOUNT_FAILURE } from '../constants/account.constants';

const initialState = {
    isVerifying: false,
    hasVerifying: false,
    error: null,
};

export const Verify_account_form = (state = initialState, action) => {
    switch (action.type) {
    case VERIFY_ACCOUNT_REQUEST:
        return {
            ...state,
            isVerifying: true,
            hasVerifying: false,
        };
    case VERIFY_ACCOUNT_SUCCESS:
        return {
            ...state,
            isVerifying: false,
            hasVerifying: true,
        };
    case VERIFY_ACCOUNT_FAILURE:
        return {
            ...state,
            isVerifying: false,
            hasVerifying: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/verify_account.reducers.js